/**
 * Created by zzy on 2019/8/7.
 */
import DeviceMap from './DeviceMap.vue'
export default DeviceMap



// WEBPACK FOOTER //
// ./src/views/monitoring/deviceMap/index.js